var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-overlay',{staticClass:"dd-overlay",attrs:{"show":_vm.show,"lock-scroll":""}},[_c('van-loading',{attrs:{"color":_vm.color,"type":_vm.type,"size":_vm.size}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }